<template>
    <div class="mt-4">
        <b-row>
          <b-col cols="auto">
              <b-card no-body class="_x_w300">
                <b-card-body>
                    <b-form v-on:submit.prevent="search">

                      <b-form-group label="Поиск">

                        <b-tabs content-class="mt-3" v-model="filter.searchMode" @input="changeTab">
                          <b-tab title="По слову" active>

                              <b-form-group 
                                label="Слово"
                                label-for="word">
                                <b-form-input 
                                  id="word" 
                                  ref="wordinput"
                                  type="text" 
                                  placeholder="Слово" 
                                  v-model="filter.word"
                                  autocomplete='given-word'/>
                                  <b-row class="mt-2">
                                      <b-col>
                                          <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӝ</b-button>
                                          <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӟ</b-button>
                                          <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӥ</b-button>
                                          <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӧ</b-button>
                                          <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӵ</b-button>
                                      </b-col>
                                  </b-row>
                              </b-form-group>

                              <b-form-group 
                                label-for="fullcompare">
                                <b-form-checkbox
                                  id="fullcompare"
                                  v-model="filter.fullcompare"
                                  name="fullcompare"
                                  value="true"
                                  unchecked-value="false">
                                  Полное совпадение
                                </b-form-checkbox>
                              </b-form-group>

                              <b-form-group 
                                label="Грамматика"
                                label-for="gr">
                                  <b-link @click.prevent="showGrammar" class="mr-2">{{filter.compiledgr}}</b-link>
                              </b-form-group>

                              <b-form-group 
                                label="Глоссы"
                                label-for="gloss">
                                  <b-link @click.prevent="showGloss" class="mr-2">{{filter.compiledgloss}}</b-link>
                              </b-form-group>
                          </b-tab>
                          <b-tab title="Полнотекстовый">

                              <b-form-group 
                                label="Текст"
                                label-for="text">
                                <b-form-input 
                                  id="text"
                                  ref="textinput"
                                  type="text" 
                                  placeholder="Текст" 
                                  v-model="filter.text"
                                  autocomplete='given-text'/>
                                  <b-row class="mt-2">
                                      <b-col>
                                          <b-button @click.prevent="letterFts" class="mr-2" variant="outline-dark">ӝ</b-button>
                                          <b-button @click.prevent="letterFts" class="mr-2" variant="outline-dark">ӟ</b-button>
                                          <b-button @click.prevent="letterFts" class="mr-2" variant="outline-dark">ӥ</b-button>
                                          <b-button @click.prevent="letterFts" class="mr-2" variant="outline-dark">ӧ</b-button>
                                          <b-button @click.prevent="letterFts" class="mr-2" variant="outline-dark">ӵ</b-button>
                                      </b-col>
                                  </b-row>
                              </b-form-group> 

                              <b-form-group 
                                label-for="fullcompare">
                                <b-form-checkbox
                                  id="fullcompare"
                                  v-model="filter.fullcompare"
                                  name="fullcompare"
                                  value="true"
                                  unchecked-value="false">
                                  Полное совпадение
                                </b-form-checkbox>
                              </b-form-group>

                          </b-tab>
                        </b-tabs>
                      </b-form-group>

                      


                      <b-form-group 
                        label="Подкорпус"
                        label-for="themes"
                        v-if="this.corpusType == 0">
                        <v-select id="filterTheme" 
                          placeholder="Подкорпус"
                          label="title"
                          :options="themes"
                          v-model="filter.theme"/>
                      </b-form-group>

                      <!--<b-form-group 
                        label="Название"
                        label-for="title"
                        v-if="this.corpusType == 1">
                        <b-form-input id="title" 
                          type="text" 
                          placeholder="Название публикации" 
                          v-model="filter.title"/>
                      </b-form-group>
                    v-if="this.corpusType == 1"-->

                      
                      <b-form-group label="Название" label-for="title">                      
                        <vue-simple-suggest
                          id="title"
                          type="text" 
                          :min-length="2"
                          class="f-control"
                          placeholder="Название публикации."
                          display-attribute="title"
                          value-attribute="id"
                          v-model="filter.title"
                          :list="getSuggestionList"
                          @select="search"
                          autocomplete='off'>
                          <input v-model="filter.title" v-on:keyup.enter="search"/>
                        </vue-simple-suggest>
                      </b-form-group>

                      <!--<b-form-group
                        label="Тип"
                        label-for="types">
                        <v-select id="type"
                          placeholder="Тип"
                          label="title"
                          :options="types"
                          v-model="filter.type"/>
                      </b-form-group>-->
                          
                    <b-form-group 
                        label="Автор(ы)"
                        label-for="filterAuthors">
                        <v-select id="filterAuthors" 
                          placeholder="Автор(ы)"
                          multiple
                          label="name"
                          :options="authors"
                          v-model="filter.authors"/>
                    </b-form-group>

                    <b-form-group 
                      label="Период публикации"
                      label-for="startYear">
                      <b-form-input id="startYear" 
                        type="number" 
                        placeholder="Начало" 
                        v-model="filter.startYear"/>

                      <b-form-input id="endYear" 
                        type="number" 
                        placeholder="Окончание" 
                        v-model="filter.endYear"/>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Показать</b-button>

                  </b-form>
                </b-card-body>
              </b-card>

              <b-card no-body class="_x_w300" v-if="filter.rows > 0 && !foundLoading ">
                  <b-card-body>
                    <div v-if="filter.searchMode == 0">Всего найдено: <b>{{ totalWords }}</b> словоупотреблений.</div>
                    <div v-else>Всего найдено: <b>{{ totalWords }}</b> предложений.</div>
                    <div><b-button @click="localSave()" variant="link">Скачать результаты в excel</b-button></div>
                    <div v-if="excelLoading"><LoadingSpinner class="centred"/></div>
                  </b-card-body>
              </b-card>
          </b-col>

          <b-col>

              <div class="foundWrap">
                <div class="loadingChartData" v-bind:class="{ active: foundLoading }">
                    <LoadingSpinner class="centred"/>
                </div>

                <div v-if="found == null">
                    <b-card no-body>
                      <b-card-body>
                        Воспользуйтесь формой поиска.
                      </b-card-body>
                    </b-card>
                </div>

                <transition name="slide-fade">
                <div v-if="show">
                    <div v-if="found.length == 0">
                        <b-card no-body>
                          <b-card-body>
                            Ничего не найдено
                          </b-card-body>
                        </b-card>
                    </div>

                    <div v-if="found.length > 0">
                      <b-card  no-body v-for="f in found" :key="f.id">
                        <b-card-body>
                            <Chunk :chunk="f" :filter="filter"/>
                        </b-card-body>
                      </b-card>
                    </div>

                </div>
                </transition>

              </div>

              <b-pagination v-if="totalPages > 1"
                @input="changePage"
                v-model="filter.page"
                :total-rows="filter.rows"
                :per-page="filter.perPage">
              </b-pagination>

          </b-col>
        </b-row>

        <Grammarywindow :opts="grammarWindowOpts" :filter="filter"/>
        <Glosswindow :opts="glossWindowOpts" :filter="filter"/>

    </div>
</template>

<script>

import LoadingSpinner from '@/components/utils/LoadingSpinner'
import { searchService, themeService, authorService, typeService, publicationService } from '@/_services'
import vSelect from 'vue-select'

import { required, minLength } from "vuelidate/lib/validators"

import Chunk from './Chunk'
import Grammarywindow from './Grammarwindow'
import Glosswindow from './Glosswindow'

import { config } from '@/_helpers'
import axios from "axios"

import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
  name: "corporasearch",
  components:{
    LoadingSpinner,
    vSelect,
    Chunk,
    Grammarywindow,
    Glosswindow,
    VueSimpleSuggest
  },    

  mounted() {
    this.init()
  },
  watch:{
    $route(){
      this.init()
    }
  },
  computed: {
    
  },
  methods: {
    showList(){
        this.filter.page = 1;
        this.loadPublications();
      },
      selectWord(){
        this.search()
      },
      init(){
        if (this.$route.path == '/body') this.corpusType = 0
        else if (this.$route.path == '/memorials') this.corpusType = 1
        this.loadAuthors();
        this.loadThemes();
        this.loadPublicatioTypes();
      },
      letter(e){
        this.filter.word+=e.target.innerText
        this.$refs.wordinput.focus()
      },
      letterFts(e){
        this.filter.text+=e.target.innerText
        this.$refs.textinput.focus()
      },
      loadAuthors(){
        authorService.authors().then(
         data => {
            this.authors = data;
          }
        )
      },
      loadThemes(){
        themeService.themes().then(
         data => {
            this.themes = data;
          }
        )
      },
      loadPublicatioTypes(){
        typeService.types().then(
         data => {
            this.types = data;
            this.filter.type = this.types.find(e => e.value == this.corpusType)
          }
        )
      },
      changeTab(){
        this.show=false;
        this.found = [];
        this.totalWords = 0;
        this.filter.rows = 0;
        this.totalPages = 0;
        this.filter.word = null;
        this.filter.text = null;
      },
      changePage(){
        this.search();
      },
      search(){
        console.log(this.filter)
        if (this.filter.word !== this.prevWord) this.filter.page = 1;
        this.prevWord = this.filter.word;
        this.foundLoading = true;
        searchService.search(this.filter).then(
        data => {
            this.show=false;
            this.found = data.content;
            this.totalWords = data.totalWords;
            this.filter.rows = data.totalElements;
            this.totalPages = data.totalPages;
            this.foundLoading = false;
            this.$nextTick(() => { this.show=true; })
          }
        )
      },
      localSave() {
        this.excelLoading = true;
        axios({
          url: config.apiUrl+'public/exportexcel',
          method: 'POST',
          responseType: 'blob',
          data: this.filter
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Результаты поиска для '+this.filter.word+'.xlsx');
          document.body.appendChild(link);
          link.click();
          this.excelLoading = false;
        });
      },
      showGrammar(){
        this.grammarWindowOpts.show = true;
      },
      showGloss(){
        this.glossWindowOpts.show = true;
      },
      getSuggestionList() {
        return publicationService.titleSugestList(this.filter.title)
        .then(data => data)
      }
  },
  data(){
    return {
      corpusType:0,
      show: false,
      found:null,
      foundLoading:false,
      excelLoading:false,
      title:null,
      themes:[],
      types:[],
      authors:[],
      totalPages:0,
      totalWords:0,
      filter:{
        searchMode:0,
        word:'',
        text:'',
        title:null,
        gr:{
          partOfSpeech:[],
          lexicalClasses:[],
          attributivizers:[],
          numerals:[],
          number:[],
          coreCases:[],
          spatialCases:[],
          spatialCases2:[],
          possessiveness:[],
          tense_mood:[],
          verbalDerivation:[],
          nonFiniteForms:[],
          imperatives:[]
        },
        gloss:[],
        startYear:null,
        endYear:null,
        theme:null,
        type: null,
        authors:null,
        fullcompare:false,
        page:1,
        perPage:10,
        rows:0,
        compiledgr:'',
        compiledgloss:''
      },
      prevWord:'',
      grammarWindowOpts:{show:false},
      glossWindowOpts:{show:false}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/style';
._x_w300 {width:300px;}

@include media-breakpoint-down($breakpoint-mobile-down) {
    ._x_w300 {width: calc(100vw - 4rem + 2px);}
}

.foundWrap {position: relative;min-height: 417px;}
.loadingChartData {position: absolute;display:none;width:100%;height:100%;background: rgba(255,255,255,0.6);z-index:1;border-radius: 0.25rem;}
.loadingChartData.active {display:block;}
.centred {top: 50%;margin-top: -20px;}
#endYear {margin-top:10px}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.slide-fade-leave {
  transform: translateY(50px);
  opacity: 1;
}

</style>